import React from 'react';

const LegendDot = ({ colorClass, style, label }) => (
  <div className="flex items-center gap-1">
    <div className={`w-3 h-0.5 ${colorClass || ''}`} style={style} />
    <span className="text-gray-600">{label}</span>
  </div>
);

const ChartLegend = ({ color, hasMA, hasBB, hasSupport }) => (
  <div className="mt-3 flex flex-wrap gap-2 text-xs">
    <LegendDot style={{ backgroundColor: color }} label="Price" />
    {hasMA && (
      <>
        <LegendDot colorClass="bg-orange-500" label="20-Day MA" />
        <LegendDot colorClass="bg-blue-500" label="50-Day MA" />
      </>
    )}
    {hasBB && (
      <>
        <LegendDot colorClass="bg-red-500 opacity-50" label="Upper Band" />
        <LegendDot colorClass="bg-green-500 opacity-50" label="Lower Band" />
      </>
    )}
    {hasSupport && (
      <>
        <LegendDot colorClass="bg-red-500 opacity-50" label="Resistance" />
        <LegendDot colorClass="bg-green-500 opacity-50" label="Support" />
      </>
    )}
  </div>
);

export default ChartLegend;
